import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-unused-vars */
import { TextProps } from '#components/chart/types';
type Payload = {
  coordinate: number;
  index: number;
  isShow: boolean;
  offset: number;
  tickCoord: number;
  value: number;
};
type XAxisProps = {
  textProps?: TextProps<Payload>;
  hide?: (payload: Payload) => boolean;
};
export const XAxisLabel = props => {
  const $ = _c(24);
  const t0 = props as XAxisProps & {
    payload: Payload;
    verticalAnchor: never;
    visibleTicksCount: never;
    tickFormatter: never;
  };
  let hide;
  let other;
  let payload;
  let textProps;
  if ($[0] !== t0) {
    const {
      payload: t1,
      textProps: t2,
      hide: t3,
      verticalAnchor,
      visibleTicksCount,
      tickFormatter,
      ...t4
    } = t0;
    payload = t1;
    textProps = t2;
    hide = t3;
    other = t4;
    $[0] = t0;
    $[1] = hide;
    $[2] = other;
    $[3] = payload;
    $[4] = textProps;
  } else {
    hide = $[1];
    other = $[2];
    payload = $[3];
    textProps = $[4];
  }
  if (hide && hide(payload)) {
    return null;
  }
  let t1;
  if ($[5] !== payload || $[6] !== textProps) {
    t1 = typeof textProps === "object" ? textProps : textProps?.(payload) || {};
    $[5] = payload;
    $[6] = textProps;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let forceShow;
  let hideLabel;
  let hideParent;
  let hideTick;
  let rest;
  if ($[8] !== t1) {
    ({
      hideParent,
      forceShow,
      hideLabel,
      hideTick,
      ...rest
    } = t1);
    $[8] = t1;
    $[9] = forceShow;
    $[10] = hideLabel;
    $[11] = hideParent;
    $[12] = hideTick;
    $[13] = rest;
  } else {
    forceShow = $[9];
    hideLabel = $[10];
    hideParent = $[11];
    hideTick = $[12];
    rest = $[13];
  }
  let t2;
  if ($[14] !== payload.value) {
    t2 = <tspan dy="1em">{payload.value}</tspan>;
    $[14] = payload.value;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== forceShow || $[17] !== hideLabel || $[18] !== hideParent || $[19] !== hideTick || $[20] !== other || $[21] !== rest || $[22] !== t2) {
    t3 = <text {...other} {...rest} data-hide-parent={hideParent} data-force-show={forceShow} data-hide-label={hideLabel} data-hide-tick={hideTick}>{t2}</text>;
    $[16] = forceShow;
    $[17] = hideLabel;
    $[18] = hideParent;
    $[19] = hideTick;
    $[20] = other;
    $[21] = rest;
    $[22] = t2;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  return t3;
};